import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@apovisio/ui/styles.css';
import './styles/app.css';
import './lib/zod-locale';
import { App } from './app/App';

const root = document.getElementById('root');
if (!root) throw new Error('Élément #root introuvable');
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
